import React from 'react';
import CardResources from '@/components/ui/CardResources';

export type CustomHitResult = {
  title: string;
  description?: string;
  slug: string;
};

type HitProps = {
  hit: CustomHitResult;
};

const Hit: React.VFC<HitProps> = ({ hit }) => {
  const { title, slug, description = `https://amica.gov.au/${slug}` } = hit;

  return (
    <CardResources linkName={title} linkDescription={description} link={slug} />
  );
};

export default Hit;
